module.exports = __webpack_public_path__ + "img/ying-lite.e6f52f6f.png";